import React from 'react'
import { Center } from "@chakra-ui/react";


export const Footer = () => {
  return (
    <div className='profile p-2 fs-5'>
    <Center>
    <div>Designed and build by Rohaan Telangur, 2022 All rights reserved.</div>
    </Center>
    </div>
  )
}
